var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPatientStar = function SvgIconPatientStar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFBF00",
    stroke: "#FFBF00",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.392 0c0 1.321-1.07 2.392-2.392 2.392 1.321 0 2.392 1.072 2.392 2.393 0-1.321 1.072-2.393 2.393-2.393-1.321 0-2.393-1.07-2.393-2.392zM8.972 7.177c0-1.651-1.34-2.99-2.99-2.99 1.65 0 2.99-1.34 2.99-2.99 0 1.65 1.339 2.99 2.99 2.99-1.651 0-2.99 1.339-2.99 2.99zM4.785 6.28c0 1.322-1.071 2.393-2.393 2.393 1.322 0 2.393 1.07 2.393 2.392 0-1.321 1.071-2.392 2.392-2.392-1.32 0-2.392-1.071-2.392-2.393z",
    transform: "translate(-297 -180) translate(297.926 181.27)"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPatientStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-patient-star.358b148db6b754801efe623775b7119c.svg";